// Focus Visible Polyfill
import 'focus-visible'

// CSS
import './../css/main.css'

// Internal Modules
import scroll from './modules/scroll'
import animation from './modules/animation'

scroll()
animation()
